import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Stack, Text, Title, TextInput, PasswordInput, Button, Paper, Anchor } from '@mantine/core'
import { IconMail, IconLock, IconUser } from '@tabler/icons-react'
import { useAuth } from '../hooks/useAuth'

export default function Signup() {
  const navigate = useNavigate()
  const { signup } = useAuth()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [confirmError, setConfirmError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setConfirmError('Passwords do not match')
      return
    }
    setConfirmError('')
    setLoading(true)
    await signup(email, password, confirmPassword, name)
    setLoading(false)
  }

  const inputStyles = {
    input: {
      background: 'rgba(10, 22, 40, 0.8)',
      border: '1px solid rgba(0, 255, 255, 0.15)',
      color: '#e0e8f0',
    },
    label: { color: 'var(--mantine-color-gray-4)' },
  }

  return (
    <Container size="xs" py="xl">
      <Stack align="center" gap="lg" style={{ minHeight: '50vh', justifyContent: 'center' }}>
        <Title order={2} ff="Orbitron, sans-serif" c="cyan.4">
          Create Account
        </Title>

        <Paper p="xl" className="glass" w="100%">
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput
                label="Name"
                placeholder="Your name"
                leftSection={<IconUser size={16} />}
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
                required
                styles={inputStyles}
              />

              <TextInput
                label="Email"
                placeholder="your@email.com"
                leftSection={<IconMail size={16} />}
                value={email}
                onChange={(e) => setEmail(e.currentTarget.value)}
                type="email"
                required
                styles={inputStyles}
              />

              <PasswordInput
                label="Password"
                placeholder="Choose a password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
                required
                minLength={6}
                autoComplete="new-password"
                styles={inputStyles}
              />

              <PasswordInput
                label="Confirm Password"
                placeholder="Re-enter your password"
                leftSection={<IconLock size={16} />}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.currentTarget.value)}
                required
                minLength={6}
                error={confirmError}
                autoComplete="new-password"
                styles={inputStyles}
              />

              <Button type="submit" loading={loading} fullWidth size="md">
                Create Account
              </Button>
            </Stack>
          </form>
        </Paper>

        <Text size="sm" c="dimmed">
          Already have an account?{' '}
          <Anchor c="cyan.4" onClick={() => navigate('/login')}>
            Log in
          </Anchor>
        </Text>
      </Stack>
    </Container>
  )
}
